import { withStyles, Divider } from "@material-ui/core";
import { formatDateTime } from "../../../../../dataGrid/gridUtilities";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    textAlign: "left",
    display: "flex",
    padding: "0px 0px",
    color: theme.HeaderSelectedText,
  },
  dialogContent: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize,
  },
  dialogContentColor: {
    color: theme.HeaderSelectedText,
    paddingTop: 6,
    paddingBottom: 10,
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    width: "100%",
    opacity: "0.7",
    height: "0px",
  },
});

const Header = (props) => {
  const { data, address, handleClose, classes, dateTime, userName } = props;

  return (
    <div className={classes.container}>
      <div
        className={classes.dialogTitle}
        id="dialog-title"
        onClose={handleClose}
      >
        {data.name} {`#${data.code}`}
      </div>
      <div className={classes.dialogContent}>
        {address}
        <div className={classes.dialogContentColor}>
          {`Last modified on: ${formatDateTime({
            value: dateTime,
          })
            .split(" ")
            .join(" | ")} by ${userName ?? ""}`}
        </div>
      </div>
      <Divider className={classes.divider} />
    </div>
  );
};

export default withStyles(styles)(Header);
